import './brickwall.jquery.scss';

;(function($, window, document, undefined) {

	const pluginName = 'brickwall';

	class Brickwall {

		constructor(element, options) {

			this._name = pluginName;
			this._defaults = $.fn[pluginName].defaults;

			this.element = element;
			this.settings = $.extend({}, this._defaults, options);

			this.init();

		}

		init() {

			this._cacheElements();

			this.$element
				.addClass('brickwall')
				.append($(this.settings.template));

		}

		_cacheElements() {
			this.$element = $(this.element);
		}

		up () {
			this.$element.addClass('brickwall--up');
			$(':input', this.$element).prop('disabled', true);
		}

		down () {
			this.$element.removeClass('brickwall--up');
			$(':input', this.$element).prop('disabled', false);
		}

	}

	$.fn[pluginName] = function ( options ) {

		var args = arguments;

		if (options === undefined || typeof options === 'object') {
			return this.each(function() {
				if (!$.data(this, `plugin_${pluginName}`)) {
					$.data(this, `plugin_${pluginName}`, new Brickwall(this, options));
				}
			});

		} else if (typeof options === 'string' && options[0] !== '_') {

			var returns;

			this.each(function() {

				var instance = $.data(this, `plugin_${pluginName}`);

				if (instance instanceof Brickwall && typeof instance[options] === 'function') {
					returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
				}

			});

			return returns !== undefined ? returns : this;

		}

	};

	$.fn[pluginName].defaults = {
		template: `<div class="brickwall__overlay">
							  <div class="brickwall__loader">
							    <img src="${STATIC_URL}/images/ripple.svg" alt="Loading..." />
							  </div>
							</div>`
	};


})(jQuery, window, document);
